import { render, staticRenderFns } from "./saved-search.vue?vue&type=template&id=3bca5c1a&"
import script from "./saved-search.vue?vue&type=script&lang=js&"
export * from "./saved-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports